// Gift short codes are bearer credentials. Remove them before any tracker event
// enters the queue, including encoded login redirects and referrer fields.
export function redactGiftLinks(value) {
  if (typeof value === 'string') return value.replace(/(?:\/|%(?:25)*2f)g(?:\/|%(?:25)*2f)[A-Za-z][A-Za-z0-9]{7}(?![A-Za-z0-9])/gi, '/g/:code')
  if (Array.isArray(value)) return value.map(redactGiftLinks)
  if (value && Object.getPrototypeOf(value) === Object.prototype) return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, redactGiftLinks(item)]))
  return value
}
